var $ = $.noConflict();

    $('.carousel_container #carousel_ul3').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  infinite: true,
  prevArrow: '.carousel_container #left_scroll3',
  nextArrow: '.carousel_container #right_scroll3',
  responsive: [{
 breakpoint: 1024,
 settings: {
 slidesToShow: 5,
 slidesToScroll: 5,
 			}
 		}, {
 breakpoint: 640,
 settings: {
 slidesToShow: 3,
 slidesToScroll: 3,
			}
 		}, {
 breakpoint: 420,
 settings: {
 slidesToShow: 2,
 slidesToScroll: 2,
		}
 		}]
});
function searchValidationInput(device='') {
      if(device=="desktop"){
           var Inpt_lngth = $('nav#nav-bar  div.aa-InputWrapper input.aa-Input').val();
      }else{ 
           var Inpt_lngth = $('.aa-DetachedOverlay div.aa-InputWrapper input.aa-Input').val();
      }
 
  console.log("Length"+Inpt_lngth)
   if(Inpt_lngth != ''){
      $('.aa-SubmitButton').removeAttr("disabled", "false");
    
   }
    else{
  $('.aa-SubmitButton').prop("disabled","true");
     }
  setTimeout(function(){
    var totalresprdct = $(".aa-PanelSection--right").html()
  if( totalresprdct == ''){
    
      $(".aa-PanelSection--right").html("<div class='extra-jtpl-search'><p class='aa-NoResultsHeader'>No results for  "+ Inpt_lngth+".</p><a class='aa-NoResultsLink' href='/search?q=''>See all products </a></div>")
    
  } 
    if($(".aa-PanelSection--right").find(".aa-SourceHeader").length > 0){
      $(".extra-jtpl-search").remove();
    }
    if($(".aa-PanelSection--right").find(".extra-jtpl-search").length > 0){
       $(".aa-PanelSection--right").html("<div class='extra-jtpl-search'><p class='aa-NoResultsHeader'>No results for  "+ Inpt_lngth+".</p><a class='aa-NoResultsLink' href='/search?q=''>See all products </a></div>")
    }
    },300);
}
function sliderInitsMob(){

    $('.main_outerslider').slick({
       draggable: false,
            swipe: false,
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
 speed: 2000,
 prevArrow: '<span class="slick-prev first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
nextArrow: '<span class="slick-next first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
 	
  
});  
$('.main_outerslider').on('afterChange', function(event, slick, currentSlide) { 
  $('#slider_images_variant .item.slick-slide.slick-current.slick-active .mob-slider-variants .item:first-child img').trigger('click');
})
    

      var dataAlt = $(".test_img.test_img1").attr("alt");
          $( "#slider_images_variant .hello .item img" ).each(function( index ) {
          if($(this).attr("data-alt") == dataAlt){
          $(this).trigger("click");
           var index = $(".item.variant-"+dataAlt).parents(".slick-slide").attr("data-slick-index");
            $('.main_outerslider').slickGoTo(index)
           return false;
        }
});
    $('#slider_images_variant .hello.mob-slider-variants .item img').click(function(){
       var img_srcNew=($(this).attr('src'));
       $('#mobile_product_featured_img #featured_img_src').attr('src', img_srcNew);
    });
   $('#slider_images_variant .hello.mob-slider-variants .item img').on('click', function(){
     $('#slider_images_variant .hello.mob-slider-variants .item img').removeClass('active');
     $(this).addClass('active');
   });
}

$(document).ready(function(){

  
  $(".search-jtpl").attr("style","opaicty:1");
$("span.stand_logo_wrpp_jtpl span:last-child").find("img").attr("src","https://cdn.shopify.com/s/files/1/0248/9160/files/years-18_New.png?v=1696568923");
  updateSku();
setTimeout(function(){

    $(".footer_judgme-badge").find('a.jdgm-verified-count-badget').attr("href","https://judge.me/reviews/crb1.myshopify.com");
$("#autocomplete-1-input").attr("placeholder" , "Search")
  $(".aa-Input").attr("placeholder" , "Search")
  
    $('.aa-SubmitButton').prop("disabled", "true");
},3000);
$(function(){
     if($(".related_accessories_prod ul li").hasClass("old_caseProduct") && $(".related_accessories_prod ul li").hasClass("new_caseProduct"))
     {
       $(".related_accessories_prod ul li.old_caseProduct").remove();
     }
      if($(".Related_Cases_Product #carousel_inner6 ul li ").hasClass("radio_case_layout"))
      {
        $(".Related_Cases_Product").css("display","block");
      }
     var Selectlength=$("#product .product_details .quantity .search-fast .select").length;     
     if(Selectlength >0)
      {
        $(".product_details .product_preview .big_image .image.featured a.product_zoom").removeClass("zoom");
        $(".product_details .product_preview .big_image .image.featured a#zoom-image").removeClass("zoom");
        $(".product_details .product_preview .big_image .image.featured a#zoom-image").addClass("js-open-modal");
        $(".product_details .product_preview .big_image .image.featured a.product_zoom").addClass("js-open-modal");
        $(".product_details .product_preview .big_image .image.featured a.product_zoom").attr('data-modal-id','popup1');
        $(".product_details .product_preview .big_image .image.featured a#zoom-image").attr('data-modal-id','popup1');       
      }  
      }); 
$(function(){

$(".js-modal-close, .modal-overlay").click(function(e) {
  $(this).parents()
    $(".modal-box, .modal-overlay").fadeOut(50, function() {
        $(".modal-overlay").remove();
      $("body").removeClass("poped-up-jtpl");
       var selectorLi = '#carousel_inner7 ul li img'; 
       $(selectorLi).removeClass('active');
       $('.overlay-full').css('display','none');
    });    
  e.preventDefault();
  if ($(".main_outerslider").hasClass("slick-initialized")){
    $(".main_outerslider").slick('unslick');
  }
   if ($(".carousel_ulA-jtpl").hasClass("slick-initialized")){
  $(".carousel_ulA-jtpl").slick('unslick');
   }
   if ($(".slider-single").hasClass("slick-initialized")){
  $(".slider-single").slick('unslick');
   }
   if ($(".slider-nav").hasClass("slick-initialized")){
  $(".slider-nav").slick('unslick');
   }
   if ($(".mob-slider-variants").hasClass("slick-initialized")){
  $(".mob-slider-variants").slick('unslick');
   }
}); 
  $('.overlay-full').click(function(){ 
    $(".modal-box, .modal-overlay").fadeOut(50, function() {
      $(".modal-overlay").remove();
      var selectorLi = '#carousel_inner7 ul li img'; 
      $(selectorLi).removeClass('active');  
      $('.overlay-full').css('display','none');
    });  
  });
  
  });
$(document).ready(function(){
  
      $('body').on('keyup', 'nav#nav-bar input.aa-Input', function(e){ 
        e.preventDefault();
       searchValidationInput('desktop');
        });
 
  $('body').on('keyup', '.aa-DetachedOverlay input.aa-Input', function(e){ 
     e.preventDefault();
   searchValidationInput('mobile');
    });

  
    $(".aa-DetachedSearchButton").click(function() {
      setTimeout(function(){
     searchValidationInput('mobile');
            } ,200);
    });
  
 $('#zoom-image').click(function(){

   if($(window).width() > 992){
  $("#popup1").fadeIn(200);
     
   }else{
     $("#mobilepopup1").fadeIn(200);
  sliderInitsMob();
   }
    
    $("body").addClass("poped-up-jtpl");
     if (!$(".carousel_ulA-jtpl").hasClass("slick-initialized")){
     sliderInits();
     }
      
   
 });
  $(".var-image-jtpl img").click(function(e) {
  var data_src =  $(this).attr("data-img");
    $("#featured_img_src").attr("src",data_src);
    }); 


      var pathname = window.location.pathname; // Returns path only
	  var url      = window.location.href;     
      var result = pathname.slice(1,-1);
      var right_text = result.substring(0, result.indexOf("/"));
      var rest = url.substring(-1, url.lastIndexOf("/") + 0);

});
function sliderInits(){

    $('.slider-single').slick({
 	slidesToShow: 1,
 	slidesToScroll: 1,
     prevArrow: '<span class="slick-prev first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
     nextArrow: '<span class="slick-next first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
 	fade: false,
 	adaptiveHeight: true,
 	infinite: false,
	useTransform: false,
 	speed: 400,
 });
   $('.carousel_ulA-jtpl').each(function(){
     var id = $(this).attr("id");
     if($(this).find("li").length > 3){
      $('#'+id).slick({
       	slidesToShow: 3,
       	slidesToScroll: 1,
        prevArrow: '<span class="slick-prev first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
       nextArrow: '<span class="slick-next first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
       	fade: false,
       	adaptiveHeight: false,
       	infinite: false,
      	useTransform: false,
       	speed: 400,
       });
     }   
   });
 

 $('.slider-nav')
 	.on('init', function(event, slick) {
 		$('.slider-nav .slick-slide.slick-current').addClass('is-active');
 	})
 	.slick({
 		slidesToShow: 7,
 		slidesToScroll: 7,
 		dots: false,
      
       prevArrow: '<span class="slick-prev first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',
        nextArrow: '<span class="slick-next first-to-show"><img src="https://www.cutratebatteries.com/cdn/shop/t/198/assets/right-arrow.svg?v=157331817836858316391696406974" width="50" height="50"/></span>',

 		focusOnSelect: false,
 		infinite: false,
 		responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 5,
 				slidesToScroll: 5,
 			}
 		}, {
 			breakpoint: 640,
 			settings: {
 				slidesToShow: 4,
 				slidesToScroll: 4,
			}
 		}, {
 			breakpoint: 420,
 			settings: {
 				slidesToShow: 3,
 				slidesToScroll: 3,
		}
 		}]
 	});

 $('.slider-single').on('afterChange', function(event, slick, currentSlide) {
 	$('.slider-nav').slick('slickGoTo', currentSlide);
 	var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
 	$('.slider-nav .slick-slide.is-active').removeClass('is-active');
 	$(currrentNavSlideElem).addClass('is-active');
 });

 $('.slider-nav').on('click', '.slick-slide', function(event) {
 	event.preventDefault();
 	var goToSingleSlide = $(this).data('slick-index');

 	$('.slider-single').slick('slickGoTo', goToSingleSlide);
 });
  }

  
setTimeout(function(){
   $(document).on('click','li a[data-fancybox]', function (e) {
     var imgToZoom = $(this).attr("href");
     
     $(".media-slides-jtpl.slick-slide.slick-current.slick-active").find(".image-media-jtpl").attr("src" , imgToZoom);
     $("#product_featured_img").find("#featured_img_src").attr("src" , imgToZoom );
     $("#mobile_product_featured_img").find("#featured_img_src").attr("src" , imgToZoom );
    e.preventDefault();
    $("#zoom-image").trigger("click");
  });
},200);
   $(document).on('click','.image-media-nav-jtpl', function (e) {
     var imgToChange = $(this).attr("src");
     $(".media-slides-jtpl.slick-slide.slick-current.slick-active").find(".image-media-jtpl").attr("src" , imgToChange);
    e.preventDefault();
  });
  
   $(document).on('click','.first-to-show', function (e) {
     var varImgChange = $(this).parents(".main_outerslider").find(".slick-list").find(".slick-current.slick-active").find("#variant_image .item.slick-slide:first-child img").attr("src");
     $("#mobile_product_featured_img #featured_img_src").attr("src",varImgChange);
    e.preventDefault();
  });
$(window).on('resize', function(){
 $('#zoom-image').click(function(){

   if($(window).width() > 992){
  $("#popup1").fadeIn(200);
   if (!$(".carousel_ulA-jtpl").hasClass("slick-initialized")){
     sliderInits();
     }
   }else{
     $("#mobilepopup1").fadeIn(200);
   if (!$(".main_outerslider").hasClass("slick-initialized")){
     sliderInitsMob();
     } 
   }
    
    $("body").addClass("poped-up-jtpl");

      
   
 });
  $(".var-image-jtpl img").click(function(e) {
  var data_src =  $(this).attr("data-img");
    $("#featured_img_src").attr("src",data_src);
    }); 
  $(".js-modal-close, .modal-overlay").trigger("click");

});  
  
  //getVariantcharngeVals();
 
/** end check available variants on change *****/
//getSwiperProduct();
// custom related products end

// Show the first tab by default
$('.tabs-stage div').hide();
$('.no-tabs-stage').children("div").hide(); 
$('.no-tabs-stage div:first').show();
$('.tabs-stage div:first').show();
$('.tabs-nav li:first').addClass('tab-active');
  $('.tabs-stage .here-new-case').show();
  $('.no-tabs-stage .here-new-case').show();
  var currnt_Sku= $('.sku-jtpl').html();
   $('.'+currnt_Sku).show();
  updateSku();
// Change tab class and display content
$('.tabs-nav a').on('click', function(event){
event.preventDefault();
$('.tabs-nav li').removeClass('tab-active');
$(this).parent().addClass('tab-active');
$('.tabs-stage div').hide();
$('.no-tabs-stage div').hide();
$($(this).attr('href')).show();
  var data_target = $(this).attr('href');
$(data_target +' div').show();
  updateSku();
});
// sitemap page js start
$('li.custom-menus-list').click(function (e) {
e.preventDefault();
$(this).prevAll('li.custom-menus-list').removeClass('active');
$(this).toggleClass('active');  
$(this).nextAll('li.custom-menus-list').removeClass('active');
});
// sitemap page js end


// faq page js start
$(document).on("click",".d1",function(e) {
e.preventDefault();
e.stopPropagation(); 
$(this).prevAll('.d1').removeClass('active');
$(this).toggleClass('active');
$(this).nextAll('.d1').removeClass('active');
});
// faq page js end

// custom product section if lenght is > 0 show hide start
// var get_accessories_len = $('ul.total_count_li.related_accessories_ul_section li').length;
// if(get_accessories_len > 0 ){
// $('.product-type-battery').show();
// $('h1.related-heading.hello.total_count').show();

// }else{
// $('.product-type-battery').css('display','none');
// $('h1.related-heading.hello.total_count').hide();
// }

// var get_accessories_len1 = $('ul.swiper-wrapper.collection-matrix.product.infinite_scroll_related._0 li').length;
// if(get_accessories_len1 > 0 ){
// $('.product_container.span12.csmt-narrow-container').show();

// }else{
// $('.product_container.span12.csmt-narrow-container').hide();
// }
// custom product section if lenght is > 0 show hide end

$('.check input').click(function(){
var link  =  $(this).parents('li').find('a').attr('href');
window.location.href = link;
});
// related product slider start


// related product slider end
});
// custom related products start
// custom related products Related charger start
// $('.collection-matrix li').each(function(index){
// if(index < 5) {
// $(this).show();
//   $('div#loadMore').show();
// } else {
// $(this).hide();
//   $('div#loadMore').hide();
// }
// });
// $('div#loadMore1').click(function() {

// $('img.gif_img1').show();
// setTimeout(function() {
// $('.collection-matrix li').css('display','block');
// $('div#loadMore1').hide();
// $('img.gif_img1').hide();   
// $('#show_lesss').show();

// }, 2500);
// });
// $('div#show_lesss').click(function () {
// $('img.gif_img1').show();   
// setTimeout(function() {
// $('.collection-matrix li').each(function(index){
// if(index < 5) {
// $(this).show();
// } else {
// $(this).hide();
// }
//  });
//  $('img.gif_img1').hide();  
// $('div#show_lesss').hide();
// $('div#loadMore1').show();
//  }, 2500);
// });


  function getVisibleCount() {
    let width = $(window).width();
    if (width > 768 && width < 1281) {
      console.log("we are here " + width);
      return 6;
    } else if (width <= 768) {
      console.log("we are here2 " + width);
      return 6;
    } else {
      console.log("we are here3 " + width);
      return 5;
    }
  }

  function showInitialItems() {
    let visibleCount = getVisibleCount();
    $('.collection-matrix li').each(function (index) {
      if (index < visibleCount) {
        $(this).show();
        $('div#loadMore1').show();
      } else {
        $(this).hide();
        $('div#loadMore1').show(); // still show loadMore initially
      }
    });
    $('#show_lesss').hide(); // Hide "Show Less" initially
  }

  showInitialItems();

  $('div#loadMore1').click(function () {
    $('img.gif_img1').show();
    setTimeout(function () {
      $('.collection-matrix li').show();
      $('div#loadMore1').hide();
      $('img.gif_img1').hide();
      $('#show_lesss').show();
    }, 2500);
  });

  $('div#show_lesss').click(function () {
    $('img.gif_img1').show();
    setTimeout(function () {
      showInitialItems();
      $('img.gif_img1').hide();
    }, 2500);
  });

  // Optional: Recalculate visible items on window resize
  $(window).resize(function () {
    showInitialItems();
  });



// custom related products Related charger end
// custom related products Related Accessories start
$(document).ready(function () {

  function getVisibleCount() {
    let width = $(window).width();
    if (width > 768 && width < 1281) {
      console.log("we are here " + width);
      return 6;
    } else if (width <= 768) {
      console.log("we are here2 " + width);
      return 6;
    } else {
      console.log("we are here3 " + width);
      return 5;
    }
  }

  function relatedAccesories() {
    let visibleCount = getVisibleCount();
    let items = $('ul.total_count_li.related_accessories_ul_section li');
    
    items.each(function (index) {
      if (index < visibleCount) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    // Show "Load More" only if there are more items than visibleCount
    if (items.length > visibleCount) {
      $('#loadMore').show();
    } else {
      $('#loadMore').hide();
    }

    $('#showLess11').hide(); // Always hide "Show Less" on init/reset
  }

  relatedAccesories();

  $('div#loadMore').click(function () {
    $(this).parents('.load_more_content').find('img.gif_img').show();

    setTimeout(function () {
      $('ul.total_count_li.related_accessories_ul_section li').show();
      $('img.gif_img').hide();
      $('div#loadMore').hide();
      $('div#showLess11').show();
    }, 2500);
  });

  $('div#showLess11').click(function () {
    $('img.gif_img').show();

    setTimeout(function () {
      relatedAccesories();
      $('img.gif_img').hide();
    }, 2500);
  });

  // Optional: Reapply visible items on resize
  $(window).resize(function () {
    relatedAccesories();
  });

});



// function relatedAccesories(){
// $('ul.total_count_li.related_accessories_ul_section li').each(function(index){


// if(index < 5) {
// $(this).show();
// $('#loadMore').hide();
// } else {
// $(this).hide();
// $('#loadMore').show();
// } 

    
// });
// }
// relatedAccesories();

// $('div#loadMore').click(function() {
// $(this).parents('.load_more_content').find('img').show();

// setTimeout(function() {
// $('ul.total_count_li.related_accessories_ul_section li').css('display','block');
// $('img.gif_img').hide();   
// $('div#loadMore').hide();
// $('div#showLess11').show();
// }, 2500);
// });
// $(' div#showLess11').click(function() {
// $('img.gif_img').show();   
//setTimeout(function() {
//$('ul.total_count_li.related_accessories_ul_section li').each(function(index){
//  if(index < 5) {
//$(this).show();
//} else {
//$(this).hide();
//}
//});




  
//$('img.gif_img').hide();
// $('div#loadMore').show();
//$('div#showLess11').hide();
//}, 2500);
//});

if ($(window).width() < 760) {
$(".tabs.custom-tabs-section-jtpl .table").wrap("<div class='table-wrapper'></div>");
$(".tabs.custom-tabs-section-jtpl .table .rows_top").nextAll('.rows_center, .rows_center2').wrapAll("<div class='row-wrapper'></div>");
  
}

 function getSwiperProduct(){
var swiper = new Swiper('.related-accessories.infinite_scroll_div.swiper-container', {
slidesPerView: 3,
slidesPerGroup: 3,
spaceBetween: 20,
noSwiping: false,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
320: {
slidesPerView: 2,
spaceBetween: 30
},
480: {
slidesPerView: 2,
spaceBetween: 30
},
768: {
slidesPerView: 3,
spaceBetween: 30
},
// when window width is >= 480px
1024: {
slidesPerView: 4,
spaceBetween: 40
},
// when window width is >= 640px
1280: {
slidesPerView: 5,
spaceBetween: 50
}
}
});


var swiper1 = new Swiper('.span12.related_prods.my_custom_code.swiper-container', {
slidesPerView: 3,
slidesPerGroup: 3,
spaceBetween: 20,
noSwiping: false,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
320: {
slidesPerView: 2,
spaceBetween: 30
},
480: {
slidesPerView: 2,
spaceBetween: 30
},
768: {
slidesPerView: 3,
spaceBetween: 30
},
// when window width is >= 480px
1024: {
slidesPerView: 4,
spaceBetween: 40
},
// when window width is >= 640px
1280: {
slidesPerView: 5,
spaceBetween: 50
}
}
});

}

setTimeout(function(){
$(".custom_coll-tab:first").addClass("active");

},10);


$(".custom_coll-tab").click(function(e){
e.preventDefault();
$(".custom_collection-tab").addClass("custom_height");
var $this = $(this);
$(".custom_coll-tab").removeClass("active");
$this.addClass("active");
$('.collection-tab-content').html('');
var tag_list = $(this).attr("data-href")+"?view=collectionstabs";

$(".main-loader-div-cstm").css("display","flex");
// alert(tag_list);
$.ajax({
url:tag_list,
type: "GET", //send it through get method
async: true, 
success: function(response) {
// console.log(response);
var coll_nav = $('.collection-tab-content').html(response);      
var html_tag = document.documentElement,
// i = 0, -> moved to be inside of for()
img_lazy = document.querySelectorAll('img[data-src]:not(.dont), picture[data-srcset]:not(.dont)'),
header_id = document.getElementById('header'),
header_inner = document.getElementById('header-inner'),
header_outer_id = document.getElementById('header-outer'),
nav_id = document.getElementById('nav'),
nav_bar_id = document.getElementById('nav-bar'),
isMobile = true,
global_dir,
i;
for (i = 0; i < img_lazy.length; i = i + 1) {
img_lazy[i].classList.add('lazy');
if (!img_lazy[i].hasAttribute('src')) {
img_lazy[i].setAttribute('src', img_lazy[i].getAttribute('data-src'));
}
}
window.dispatchEvent(ratingsEvt);
window.dispatchEvent(listCollectionSliderEvt);
//slider inititalize
console.log(coll_nav);
$(".main-loader-div-cstm").css("display","none");
$(".custom_collection-tab").removeClass("custom_height");
}

});
$('.collection-tab-content').html('');
});

